"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFactory = void 0;
class FeatureFactory {
    #factories = new Map();
    register(featureKind, factoryFn) {
        if (this.#factories.has(featureKind)) {
            throw new Error(`FeatureFactory is already registered for feature ${featureKind}`);
        }
        this.#factories.set(featureKind, factoryFn);
    }
    createFeature(config, card, ctx) {
        const factory = this.#factories.get(config.kind);
        if (!factory) {
            throw new Error(`FeatureFactory is not found for feature ${config.kind}`);
        }
        return factory(config, card, ctx);
    }
}
exports.FeatureFactory = FeatureFactory;
